import { render, staticRenderFns } from "./BaseUploadFile.vue?vue&type=template&id=533395b2&scoped=true"
import script from "./BaseUploadFile.vue?vue&type=script&lang=js"
export * from "./BaseUploadFile.vue?vue&type=script&lang=js"
import style0 from "./BaseUploadFile.vue?vue&type=style&index=0&id=533395b2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533395b2",
  null
  
)

export default component.exports